var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    width: "100%"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.24 14.1v2.5a1.665 1.665 0 0 1-1.816 1.667 16.492 16.492 0 0 1-7.192-2.558 16.25 16.25 0 0 1-5-5 16.492 16.492 0 0 1-2.558-7.226 1.667 1.667 0 0 1 1.658-1.816h2.5A1.667 1.667 0 0 1 7.5 3.1c.105.8.301 1.586.583 2.342A1.667 1.667 0 0 1 7.707 7.2L6.65 8.258a13.333 13.333 0 0 0 5 5l1.058-1.058a1.667 1.667 0 0 1 1.758-.375 10.7 10.7 0 0 0 2.342.584A1.667 1.667 0 0 1 18.24 14.1Z",
    stroke: "#F2F2F2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgPhone;